import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { File } from '../models/File';

@Injectable({
    providedIn: 'root'
})
export class FileService {

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/files";
    }

    downloadFile(datos: object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<any>(this.url + "/instructions", JSON.stringify(datos), { headers: iheaders });
    }

    updateNocs(data: any, user: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.nocFileData = data;
        return this.http.post<any>(this.url + "/updateNocs", JSON.stringify(fileDto), { headers: iheaders });
    }

    updateInternalCodes(data: any, user: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.nocFileData = data;
        return this.http.post<any>(this.url + "/updateInternalCodes", JSON.stringify(fileDto), { headers: iheaders });
    }

    updateStock(data: any, user: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.nocFileData = data;
        return this.http.post<any>(this.url + "/updateStock", JSON.stringify(fileDto), { headers: iheaders });
    }

    usersFile(data: any, user: string){
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.fileBase64 = data;
        return this.http.post<any>(this.url + "/usersFile", JSON.stringify(fileDto), { headers: iheaders });
    }

    clothesFile(data: any, user: string, extension: string){
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.fileBase64 = data;
        fileDto.extension = extension;
        return this.http.post<any>(this.url + "/clothesFile", JSON.stringify(fileDto), { headers: iheaders });
    }

    nocsFile(data: any, user: string, extension: string){
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.fileBase64 = data;
        fileDto.extension = extension;
        return this.http.post<any>(this.url + "/nocsFile", JSON.stringify(fileDto), { headers: iheaders });
    }

    pricesFile(data: any, user: string, extension: string){
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.fileBase64 = data;
        fileDto.extension = extension;
        return this.http.post<any>(this.url + "/pricesFile", JSON.stringify(fileDto), { headers: iheaders });
    }

    familiesFile(data: any, user: string, extension: string){
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        let fileDto: File = new File();
        fileDto.nid = user;
        fileDto.fileBase64 = data;
        fileDto.extension = extension;
        return this.http.post<any>(this.url + "/familiesFile", JSON.stringify(fileDto), { headers: iheaders });
    }
}
